//公共函数
//base64
import base64 from './base64.js'
import http from './http.js'
//工具
import util from './util.js'
import date from './date.js'
import cache from './cache.js'
//数据模块

export default {
	base64,
	http,
	util,
	date,
	cache
}


// WEBPACK FOOTER //
// ./src/common/index.js